import { buildApiUrl } from '../config/apiConfig';

const PHYSICAL_TYPES = new Set(['item', 'items', 'physical']);

export function isPhysicalCartLine(item) {
  return PHYSICAL_TYPES.has(String(item?.productType || '').toLowerCase());
}

/**
 * @param {object[]} items - Líneas del carrito
 * @returns {Promise<{ valid: boolean, lines: Array<{ id, productType, itemVariantId, requestedQuantity, availableStock, maxQuantity, ok, message }> }>}
 */
export async function checkCartLinesStock(items) {
  const physical = (items || []).filter(isPhysicalCartLine);
  if (physical.length === 0) {
    return { valid: true, lines: [] };
  }

  const payload = physical.map((item) => ({
    id: item.id,
    productType: item.productType,
    quantity: item.quantity,
    itemVariantId: item.itemVariantId ?? undefined,
  }));

  const response = await fetch(buildApiUrl('/api/cart/stock-check'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: payload }),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || 'No se pudo verificar el stock.');
  }

  return {
    valid: Boolean(data.valid),
    lines: Array.isArray(data.lines) ? data.lines : [],
  };
}

export function matchStockLine(stockLines, id, productType, itemVariantId) {
  return (stockLines || []).find(
    (line) =>
      String(line.id) === String(id) &&
      String(line.productType) === String(productType) &&
      (line.itemVariantId ?? null) === (itemVariantId ?? null),
  );
}

export function notifyStockWarning(message) {
  if (!message) return;
  if (typeof window !== 'undefined' && window.dispatchEvent) {
    window.dispatchEvent(
      new CustomEvent('showNotification', {
        detail: { message, type: 'warning' },
      }),
    );
  }
}
